import { ClearOutlined } from '@ant-design/icons';
import { Badge, Button } from 'antd';
import { RESET_FILTER_TEXT } from '../common/constants';
import useRetainedTableState from '../hooks/useRetainedTableFilterState';
import Portal from './Portal';

const ResetFilterButton = ({ tableKey }) => {
  const {
    resetRetainedFilterState,
    hasRetainedFilters,
  } = useRetainedTableState();

  return (
    <>
      <Portal portalId="header-right-content">
        <Badge dot={hasRetainedFilters(tableKey)} className="filter-dot">
          <Button
            className="common-button ml-16"
            size="middle"
            icon={<ClearOutlined />}
            onClick={() => {
              resetRetainedFilterState(tableKey);
            }}
          >
            {RESET_FILTER_TEXT}
          </Button>
        </Badge>
      </Portal>
      <Portal portalId="header-right-content-phones">
        <Badge dot={hasRetainedFilters(tableKey)} className="filter-dot">
          <Button
            className="common-button ml-16"
            size="middle"
            icon={<ClearOutlined />}
            onClick={() => {
              resetRetainedFilterState(tableKey);
            }}
          >
            {RESET_FILTER_TEXT}
          </Button>
        </Badge>
      </Portal>
    </>
  );
};

export default ResetFilterButton;
